define(["require", "exports", "./ServiceBase"], function (require, exports, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StockRouteNetworkManagementService = void 0;
    class StockRouteNetworkManagementService extends ServiceBase_1.ServiceBase {
        constructor(httpProtocol, hostName, serviceName, proxyUrl) {
            super("StockRouteNetworkManagement", httpProtocol, hostName, serviceName, proxyUrl);
        }
        addParcelsToChangeRequest(crId, crLgaCode, crLgaName, parcels) {
            let p = {};
            p.crId = crId;
            p.crLgaCode = crLgaCode;
            p.crLgaName = crLgaName;
            p.parcels = parcels;
            return this.post("AddParcelsToChangeRequest", p, (json) => {
                return json;
            });
        }
        createSrCrAmendment(cr) {
            let p = {};
            p.cr = cr;
            return this.post("CreateSrCrAmendment", p, (json) => {
                return json;
            });
        }
        createSrCrApplication(changeType, parcels) {
            let p = {};
            p.changeType = changeType;
            p.parcels = parcels;
            return this.post("CreateSrCrApplication", p, (json) => {
                return json;
            });
        }
        persistSrCrApplication(application) {
            let p = {};
            p.application = application;
            return this.post("PersistSrCrApplication", p, (json) => {
                return json;
            });
        }
        readSrCrApplication(applicationId, includeArchivedChangeRequests) {
            let p = {};
            p.applicationId = applicationId;
            p.includeArchivedChangeRequests = includeArchivedChangeRequests;
            return this.post("ReadSrCrApplication", p, (json) => {
                return json;
            });
        }
        readSrCrApplicationByCrId(id, includeArchivedChangeRequests) {
            let p = {};
            p.id = id;
            p.includeArchivedChangeRequests = includeArchivedChangeRequests;
            return this.post("ReadSrCrApplicationByCrId", p, (json) => {
                return json;
            });
        }
        validateApplication(application) {
            let p = {};
            p.application = application;
            return this.post("ValidateApplication", p, (json) => {
                return json;
            });
        }
        validateChangeRequest(cr) {
            let p = {};
            p.cr = cr;
            return this.post("ValidateChangeRequest", p, (json) => {
                return json;
            });
        }
        uploadSrCrDocument(crId, crDocumentType, documentName, base64Document) {
            let p = {};
            p.crId = crId;
            p.crDocumentType = crDocumentType;
            p.documentName = documentName;
            p.base64Document = base64Document;
            return this.post("UploadSrCrDocument", p, (json) => {
                return json;
            });
        }
        getSrCrDocument(documentId) {
            let p = {};
            p.documentId = documentId;
            return this.requestFile("GetSrCrDocument", p);
        }
        generateAggregatedSrCrReport(reportParameters) {
            let p = {};
            p.reportParameters = reportParameters;
            return this.post("GenerateAggregatedSrCrReport", p, (json) => {
                return json;
            });
        }
        getAggregatedSrCrReport(reportFileId) {
            let p = {};
            p.reportFileId = reportFileId;
            return this.requestFile("GetAggregatedSrCrReport", p);
        }
        getAuthorisedLgas() {
            let p = {};
            return this.post("GetAuthorisedLgas", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgasWithGeometry(returnPolyline, generalise) {
            let p = {};
            p.returnPolyline = returnPolyline;
            p.generalise = generalise;
            return this.post("GetAuthorisedLgasWithGeometry", p, (json) => {
                return json;
            });
        }
        getConfiguration() {
            let p = {};
            return this.post("GetConfiguration", p, (json) => {
                return json;
            });
        }
        getLgas() {
            let p = {};
            return this.post("GetLgas", p, (json) => {
                return json;
            });
        }
        getLotPlanQvasEvaluation(lotPlan) {
            let p = {};
            p.lotPlan = lotPlan;
            return this.post("GetLotPlanQvasEvaluation", p, (json) => {
                return json;
            });
        }
        getUser() {
            let p = {};
            return this.post("GetUser", p, (json) => {
                return json;
            });
        }
        keepAlive() {
            let p = {};
            return this.post("KeepAlive", p, (json) => {
                return json;
            });
        }
    }
    exports.StockRouteNetworkManagementService = StockRouteNetworkManagementService;
});
